/*
 * @Author: Jason
 * @Date: 2020-09-11 14:03:51
 * @LastEditors: Jason
 * @LastEditTime: 2020-10-10 14:09:34
 */
const pages = [
  { link: '/login', componentName: 'Login', title: '登录'},
  {
	  link: '/', componentName: 'Main', title: '',
    children: [
	    { link: '/home', componentName: 'Home', title: '首页'},
	    { link: '/nurse', componentName: 'Nurse', title: '护士站列表'},
	    { link: '/nurse/:id', componentName: 'NurseDetail', title: '护士站详情'},
	    { link: '/baby', componentName: 'Baby', title: '宝宝列表'},
	    { link: '/baby/:id', componentName: 'BabyRecord', title: '宝宝记录'},
    ]
  }
]
export default pages



// WEBPACK FOOTER //
// ./src/common/pages.js